import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const createPersistedReducer = (reducers) => {
  const persistedReducer = persistReducer(
    {
      key: "root",
      storage: storage,
    },
    reducers
  );

  return persistedReducer;
};

export default createPersistedReducer;
